import {Injectable} from "@angular/core";
import {ActivatedRoute, ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import * as fromStore from "../store";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {UserSubscriptionIds, UserSubscriptionType} from "../user/user-subscription";
import {combineLatest} from "rxjs";
import {Config} from "../config/config";

@Injectable()
export class AddWebsiteResolver implements Resolve<any|null> {

  private userSubscriptionIds = UserSubscriptionIds;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _route: ActivatedRoute,
    private _router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      combineLatest(
        this._store.select(fromStore.getUserLoaded),
        this._store.select(fromStore.getUserLocalStorageLoaded)
        )
        .pipe(
          filter(([userLoaded, userLocalStorageLoaded]) => userLoaded && userLocalStorageLoaded),
          switchMap(() => combineLatest(
              this._store.select(fromStore.getUserSubscription),
              this._store.select(fromStore.getUserLocalStorage)
            )),
          first()
        )
        .subscribe(([userSubscription, userLocalStorage]) => {
          if (userSubscription && (userSubscription.platformPaidClient || userSubscription.trialClient || userSubscription.trialOptimizerClient || userSubscription.trialBoosterClient
            || userSubscription.subscriptionId === Config.defaultStarterPlanId)) {
            resolve(userLocalStorage);
          }
       /*   else if (userSubscription.type === UserSubscriptionType.PLATFORM) {
            this._router.navigate(['/websites']);
            reject();
          }*/
          else {
            resolve(true);
          }
        });
    });
  }
}
